import React from 'react';

const ICONS = {
  total: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 9.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" fill="#fff" />
      <path d="M16.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" fill="#fff" />
      <path d="M2 20c1.5-3 6-4 10-4s8.5 1 10 4" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  male: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="4" fill="#fff" />
      <path d="M14 6l4-4M18 2h-3M18 2v3" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 20c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  female: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="7" r="4" fill="#fff" />
      <path d="M12 11v5" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M9 16h6" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 19v2" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  paid: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.6" />
      <path d="M12 7v10M9.5 9.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5S13.4 12 12 12s-2.5 1.1-2.5 2.5S10.6 17 12 17s2.5-1.1 2.5-2.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  active: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.6" />
      <path d="M8 12l3 3 5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  unapproved: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.6" />
      <path d="M12 8v5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="12" cy="16" r="1" fill="#fff" />
    </svg>
  ),
  deactivated: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.6" />
      <path d="M15 9l-6 6M9 9l6 6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  ),
};

const THEMES = {
  total:       { bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102,126,234,0.45)' },
  male:        { bg: 'linear-gradient(135deg, #4facfe 0%, #00c5fb 100%)', shadow: 'rgba(79,172,254,0.45)' },
  female:      { bg: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(245,87,108,0.40)' },
  paid:        { bg: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)', shadow: 'rgba(247,151,30,0.40)' },
  active:      { bg: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', shadow: 'rgba(17,153,142,0.40)' },
  unapproved:  { bg: 'linear-gradient(135deg, #f7971e 0%, #f5a623 100%)', shadow: 'rgba(247,151,30,0.40)' },
  deactivated: { bg: 'linear-gradient(135deg, #cb2d3e 0%, #ef473a 100%)', shadow: 'rgba(203,45,62,0.40)' },
};

export default function StatsCard({ title, value, type }) {
  const icon = ICONS[type] || ICONS.total;
  const { bg, shadow } = THEMES[type] || THEMES.total;

  return (
    <div className="stat-card" style={{ background: bg, boxShadow: `0 8px 24px ${shadow}` }}>
      <div className="stat-card-icon" aria-hidden>{icon}</div>
      <div className="stat-card-value">{value ?? '—'}</div>
      <div className="stat-card-title">{title}</div>
    </div>
  );
}
